import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 60;
  display: flex;
  align-items: flex-end;
`;

export const Backdrop = styled.button`
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
`;

export const Sheet = styled.div`
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  max-height: 85vh;
`;

export const DragHandle = styled.div`
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: #e0e0e0;
  margin: 8px auto 14px;
`;

export const ImageWrap = styled.div`
  position: relative;
`;

export const DragHandleWrap = styled.div`
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: min(42vw, 300px);
  object-fit: cover;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const TitleWrap = styled.div`
  padding: 14px 20px 0;
`;

export const Title = styled.div`
  font-size: 14px;
  color: #6f7d95;
  text-align: center;
`;

export const ListWrap = styled.div`
  padding: 16px 20px 4px;
  display: grid;
  gap: 8px;
`;

export const ListCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border-radius: 16px;
  padding: 12px;
`;

export const ListIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
`;

export const ListContent = styled.div`
  flex: 1;
`;

export const ListText = styled.div`
  font-size: 14px;
  color: #000;
`;

export const BtnWrap = styled.div`
  padding: 0 20px 22px;
  display: grid;
  gap: 0;
`;

export const PrimaryBtn = styled.button`
  border: none;
  border-radius: 10px;
  height: 44px;
  background: linear-gradient(90deg, #144fcf 0%, #2a70f4 100%);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`;

export const SecondaryBtn = styled.button`
  border: none;
  border-radius: 10px;
  height: 44px;
  background: transparent;
  color: #1f59d8;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: -10px;
`;

